module.exports = __webpack_public_path__ + "static/media/overview-blue.0ba96c20.svg";